import React from 'react';
import { PropTypes } from 'prop-types';

// Components
import SearchInner from './SearchInner';
import ErrorHandler from '../../_molecules/ErrorHandler';
import SearchAuthCheck from '../../../../../algolia-search/js/components/sections/SearchAuthCheck';

// Helpers
import { urlToSearchState } from '@general/helpers/search.helpers';
import useSearchType from '../../../../../algolia-search/js/hooks/useSearchType';
import { SearchTypeProvider } from '@context/searchTypeContext';
import { ViewTypeContext } from '@context/viewTypeContext';
import useViewType from '@hooks/useViewType';

const { view } = urlToSearchState(window.location);

const Search = ({
    children,
    aroundLatLngViaIP = false,
    displayMap = false,
    defaultViewType = 'card',
    displayPagingToolbar = true,
    displaySearchBox,
    displaySearchOptions,
    filters,
    optionalFilters = [],
    hitsPerPage = 24,
    index,
    initialSearchState,
    maxWidth,
    updateSearchStateUrl = false,
    refinementComponent,
    AboveSearchBoxComponent,
}) => {
    const { viewType, setViewType } = useViewType({
        defaultView: view || defaultViewType,
    });
    const { searchType, setSearchType } = useSearchType({
        defaultSearchType: { index },
    });

    return (
        <ErrorHandler>
            <SearchTypeProvider searchType={searchType} setSearchType={setSearchType}>
                <ViewTypeContext.Provider value={[viewType, setViewType]}>
                    <SearchAuthCheck>
                        <SearchInner
                            aroundLatLngViaIP={aroundLatLngViaIP}
                            displayMap={displayMap}
                            displayPagingToolbar={displayPagingToolbar}
                            displaySearchBox={displaySearchBox}
                            displaySearchOptions={displaySearchOptions}
                            filters={filters}
                            hitsPerPage={hitsPerPage}
                            index={index}
                            initialSearchState={initialSearchState}
                            maxWidth={maxWidth}
                            optionalFilters={optionalFilters}
                            updateSearchStateUrl={updateSearchStateUrl}
                            RefinementComponent={refinementComponent}
                            AboveSearchBoxComponent={AboveSearchBoxComponent}
                        >
                            {children}
                        </SearchInner>
                    </SearchAuthCheck>
                </ViewTypeContext.Provider>
            </SearchTypeProvider>
        </ErrorHandler>
    );
};

Search.propTypes = {
    children: PropTypes.node.isRequired,
    aroundLatLngViaIP: PropTypes.bool,
    displayMap: PropTypes.bool,
    defaultViewType: PropTypes.string,
    displayPagingToolbar: PropTypes.bool,
    displaySearchBox: PropTypes.bool,
    displaySearchOptions: PropTypes.bool,
    filters: PropTypes.string,
    hitsPerPage: PropTypes.number,
    index: PropTypes.string.isRequired,
    initialSearchState: PropTypes.object,
    maxWidth: PropTypes.string,
    optionalFilters: PropTypes.array,
    updateSearchStateUrl: PropTypes.bool,
    refinementComponent: PropTypes.any,
    AboveSearchBoxComponent: PropTypes.func,
};

export default Search;
